<app-toolbar>
  <app-breadcrumbs/>
  <app-page-search class="me-auto" [(searchString)]="filter.Global" (searchStringChange)="search$.next($event)" [(showFilters)]="filter.AdvancedFilter"/>
  <app-toolbar-list-buttons [showAdd]="PRIVILEGES.EditManufacturing | userHasPrivilege" (addClick)="goToAdd()" *transloco="let t; read: 'ime.components.action-bar'">
    <div ngbDropdown class="d-inline-block">
      <button type="button" class="btn btn-sm btn-outline-primary me-1" ngbDropdownToggle>
        <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#table-cells'">
        </svg>
        {{t('Export')}}
      </button>
      <div ngbDropdownMenu>
        <button ngbDropdownItem (click)="saveExcel(true)">{{t('All data with IME tab')}}</button>
        <button ngbDropdownItem (click)="saveExcel(false)">{{t('All data without IME tab')}}</button>
      </div>
    </div>
  </app-toolbar-list-buttons>
</app-toolbar>
<app-item-group-table *ngIf="stateKey"
                      [filter]="filter"
                      [defaultFilter]="defaultFilter"
                      [stateKey]="stateKey"
                      [search$]="search$"
                      (filterChanged)="runChangeDetector()"/>
